import { Vector3 } from 'three';

export class Patient {
  type: 'patient' = 'patient';
  constructor(
    public name: string,
    public imageId: number,
    public birthday: Date,
    public sex: string,
    public age: number,
    public description: string,
    public ima: number,
    public position: number
  ) {}
}
export class Hospital {
  type: 'hospital' = 'hospital';
  constructor(
    public name: string,
    public device: string,
    public model: string,
    public patientPosition: string
  ) {}
}

export class Scale {
  type: 'scale' = 'scale';
  constructor(
    public scale: number,
    public direction: string
  ) {}
}

export class Physics {
  type: 'physics' = 'physics';
  constructor(
    public voltage: number,
    public current: number,
    public angle: number,
    public depth: number
  ) {}
}

export class Zoom {
  type: 'zoom' = 'zoom';
  constructor(
    public window: string,
    public level: string,
    public zoom: string
  ) {}
}

export class Ring {
  type: 'ring' = 'ring';
  area: number;
  constructor(
    public center: Vector3,
    public Radius: number,
  ) {
    this.area = Math.PI * Radius * Radius;
  }
}
export type Info = Patient | Hospital | Scale | Physics | Zoom | Ring;
export type InfoType = Info['type'];
export type InfoOf<K extends InfoType> = Extract< Info, {type: K}>;
